export const TOS = () => <div>terms of service</div>;
